import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { CheckCircle } from 'lucide-react';
import type { Milestone } from '@/lib/types/milestone';

interface MilestoneCompletionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  milestone: Milestone | null;
  onConfirm: () => void;
  loading?: boolean;
}

export function MilestoneCompletionDialog({ 
  open, 
  onOpenChange, 
  milestone, 
  onConfirm, 
  loading = false 
}: MilestoneCompletionDialogProps) {
  if (!milestone) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <CheckCircle className="h-5 w-5 text-green-600" />
            Mark Milestone Complete
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Are you sure you want to mark the following milestone as complete?
            </p>
            <div className="bg-muted rounded-lg p-3 space-y-2">
              <p className="font-medium">
                {milestone.milestone_order}. {milestone.milestone_name}
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Deliverable:</strong> {milestone.deliverable}
              </p>
              <p className="text-sm text-muted-foreground">
                <strong>Type:</strong> {milestone.milestone_type.replace('_', ' ')}
              </p>
            </div>
            <p className="text-sm text-muted-foreground">
              Once marked as complete, this milestone cannot be edited or have change requests made to it.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700"
          >
            {loading ? 'Marking Complete...' : 'Mark Complete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}